import {
  defaultRowButtons,
  IndexView,
  LoggerFactory,
  SecuredMenuLinkButton
} from "lego-gui-lib";
import React, { useContext } from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { authStoreContext } from "../../core/mainStore";
import { SanContext, sanCustomerContext, SANSchema } from "./schema";
import { Build, Apps } from "@material-ui/icons";

const log = LoggerFactory.create("SAN - Index");

const indexColumns = SANSchema.extend(
  {
    customerRef: {},
    mainNumber: {},
    blocked: {},
    genericNote1: {},
    genericNote2: {},
    genericNote3: {}
  },
  { onlyGiven: true }
);

export const Index = observer(({ ...props }: any) => {
  const auth = useContext(authStoreContext);
  const canCreate = auth.isAdmin();

  const i18n = useTranslation();
  const title = i18n.t("hns:san:domain", { count: 2 });

  const san = useContext(SanContext);
  const customerSAN = useContext(sanCustomerContext);

  const rowButtons = (ctrl: any) => (
    row: any,
    key: string,
    close: () => void
  ) => {
    const def = defaultRowButtons(ctrl, {
      edit: false,
      delete: canCreate,
      copy: canCreate,
      export: true
    })(row, key, close);

    log.debug("rowButtons props", ctrl.props);

    return [
      <SecuredMenuLinkButton
        key={"view"}
        link={ctrl.props.columns.link(row)}
        title={i18n.t("common:view")}
        requiredAccess={"readable"}
      >
        <Apps color={"inherit"} />
      </SecuredMenuLinkButton>,
      <SecuredMenuLinkButton
        key={"config"}
        link={ctrl.props.columns.link(row) + "/configure/general"}
        title={i18n.t("common:config")}
        requiredAccess={"readable"}
      >
        <Build color={"inherit"} />
      </SecuredMenuLinkButton>,
      ...def
    ];
  };

  /** Due to role CR SAN Admin is allowed to operate as one of his clients, so customer aware dataSource customerSAN is needed */
  return (
    <IndexView
      dataSource={auth.isAnyCustomerOwner() ? customerSAN : san.listDataSource}
      {...props}
      title={title}
      titleButtons={() => !canCreate && <></>}
      toolbarButtons={{ delete: true, export: true }}
      rowButtons={rowButtons}
      columns={indexColumns}
    />
  );
});
